<template>
    <div class="az-form-content">
        <v-container fluid grid-list-xl style="padding-bottom: 80px">
            <v-layout wrap align-center>
                <v-flex xs12 sm12 d-flex class="pt-0" v-if="!isPropostaEnviada">
                    <span class="az-subtitle primary--text">Enviar Documentos</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-if="!isPropostaEnviada">
                    <proposta-file-upload :accept="arquivosAceitos" :repository="repository"
                                          :docsJaInseridos="documentosHabilitacao"
                                          :docs-ja-inseridos-proposta="documentosProposta"
                                          ref="azFileUploadEdital" height="80px">
                        <a @click.prevent="$refs.azFileUploadEdital.openFileSelector()">
                            <v-icon>archive</v-icon>
                            Importar Arquivos
                        </a>
                        <p>Arraste e solte os arquivos aqui para serem carregados.</p>
                    </proposta-file-upload>
                </v-flex>
                <v-layout d-flex wrap align-center class="ml-2 pt-1 pb-1">
                    <v-flex xs12 sm12 md6 d-flex class="pa-0">
                        <v-btn @click="abrirModalConfirmarAssinar(true)"
                               style="text-align: center; max-width: 250px; width: 100%;">
                            <icone-assinar-documento class="mr-1"/>
                            Assinar Selecionados
                        </v-btn>
                    </v-flex>
                </v-layout>

                <v-flex xs12 sm12 d-flex class="pb-0">
                    <span class="az-subtitle primary--text">Documentos de Proposta</span>
                </v-flex>
                <licitacao-fornecedor-documentos-tabela :documentos="documentosProposta"
                                                        ref="tabelaDocumentosProposta"
                                                        :categoria-documento="'proposta'"
                                                        @confirmar-remocao="confirmarRemocao"/>

                <v-flex xs12 sm12 d-flex class="pb-0">
                    <span class="az-subtitle primary--text">Documentos de Habilitação</span>
                </v-flex>
                <licitacao-fornecedor-documentos-tabela :documentos="documentosHabilitacao"
                                                        ref="tabelaDocumentosHabilitacao"
                                                        :categoria-documento="'habilitação'"
                                                        @confirmar-remocao="confirmarRemocao"/>

                <v-flex xs12 sm12 d-flex class="pb-0">
                    <span class="az-subtitle primary--text">Documentos de Fornecedor</span>
                </v-flex>
                <licitacao-fornecedor-documentos-tabela :documentos="documentosFornecedor"
                                                        ref="tabelaDocumentosFornecedor"
                                                        :categoria-documento="'fornecedor'"
                                                        @confirmar-remocao="confirmarRemocao"/>

                <v-flex xs12 sm12 d-flex class="pb-0">
                    <span class="az-subtitle primary--text">Documentos de Readequação de Proposta</span>
                </v-flex>
                <licitacao-fornecedor-documentos-tabela :documentos="documentosReadequacaoProposta.items"
                                                        ref="tabelaDocumentosReadequacaoProposta"
                                                        :categoria-documento="'readequação de proposta'"
                                                        @confirmar-remocao="confirmarRemocao"/>
            </v-layout>
        </v-container>
        <az-confirm @onConfirm="remover(); mostrarDialogRemoverArquivo = false;"
                    @onDecline="mostrarDialogRemoverArquivo = false"
                    v-if="mostrarDialogRemoverArquivo">
            Tem certeza que deseja remover o arquivo?
        </az-confirm>
        <az-confirm @onConfirm="sairDaTela(nextFunction); mostrarDialogConfirmarSaida = false;"
                    @onDecline="mostrarDialogConfirmarSaida = false"
                    v-if="mostrarDialogConfirmarSaida" :maxWidth=350>
            O upload de alguns arquivos ainda não terminou. Deseja sair da tela mesmo assim?
        </az-confirm>
        <selecionar-tipo-documento
            :dialog="exibirModalSelecionarTipoDocumento"
            :multiplo="loki.uploadedFiles.length > 1"
            @habilitacao="inserir('ANEXO_HABILITACAO')"
            @proposta="inserir('ANEXO_PROPOSTA')"
        />
        <modal-assinar-documentos :mostrarModalAssinarDocumentos="exibirModalConfirmarAssinar"
                                           :multiplo="manejandoMultiplos"
                                           :documentosSelecionados="documentosSelecionados"
                                           :documento-selecionado="documentoSelecionado"
                                           :fornecedor="propostaResumo.fornecedor"
                                           @fechar="exibirModalConfirmarAssinar = false"
                                           @confirmar="selecionarMetodoAssinar(documentoManejando, manejandoMultiplos)"
        />
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes} from '@/commons/constants'
import SelecionarTipoDocumento from "@/views/licitacao/detalhe/fornecedor/modal/SelecionarTipoDocumento";
import PropostaFileUpload from "@/commons/components/file/PropostaFileUpload.vue";
import EdlFileUpload from "@/commons/components/file/EdlFileUpload.vue";
import LicitacaoFornecedorDocumentosTabela from '@/views/licitacao/detalhe/fornecedor/LicitacaoFornecedorDocumentosTabela'
import IconeAssinarDocumento from '@/commons/components/icones/IconeAssinarDocumento'
import ModalAssinarDocumentos from '@/views/licitacao/detalhe/fornecedor/modal/ModalAssinarDocumentos'

export default {
      name: 'LicitacaoFornecedorDocumentos',
      components: {
          PropostaFileUpload,
          EdlFileUpload,
          SelecionarTipoDocumento,
          LicitacaoFornecedorDocumentosTabela,
          IconeAssinarDocumento,
          ModalAssinarDocumentos
      },
      data() {
            return {
                colunasTabela: [
                    {
                        text: 'Data',
                        align: 'left',
                        sortable: false,
                        width: '180px'
                    },
                    {
                        text: 'Nome',
                        sortable: false,
                        align: 'left'
                    },
                    {
                        text: 'Ações',
                        sortable: false,
                        align: 'center',
                        width: '100px'
                    }
                ],
                documentosHabilitacao: [],
                documentosProposta: [],
                documentosFornecedor: [],
                documentosReadequacaoProposta: [],
                licitacaoId: undefined,
                mostrarDialogConfirmarSaida: false,
                mostrarDialogRemoverArquivo: false,
                nextFunction: undefined,
                propostaDocumentoIdRemocao: undefined,
                exibirModalSelecionarTipoDocumento: false,
                selecionados: [],
                documentoManejando: null,
                manejandoMultiplos: null,
                exibirModalConfirmarAssinar: false,
                documentosSelecionados: [],
                documentoSelecionado: {}
            }
        },
        computed: {
            isPropostaEnviada() {
                return this.propostaResumo.enviada
            },
            repository() {
                return `repo1:licitacao/${this.licitacaoId}/propostas/fornecedor/${this.loki.user.domainId}/docsHabilitacao`
            },
            arquivosAceitos() {
                return this.parametros.propriedadesLicitacao.extensao
            },
            ...mapState(['loki', 'propostaResumo', 'parametros'])
        },
        beforeRouteLeave(to, from, next) {
            if (this.isUploadEmAndamento()) {
                this.confirmarSaidaDaTela(next)
            } else {
                this.sairDaTela(next)
            }
        },
        created() {
            this.desabilitarLoadingGlobal()
        },
        async mounted() {
            this.setLicitacaoId(this.$route.params.id)
            await this.buscarDocumentos()
        },
        watch: {
            'loki.uploadedFiles': {
                async handler() {
                  if (this.isUploadArquivosTemporariosCompleto()) {
                    if (this.ehModoManual()){
                      await this.inserir('ANEXO_HABILITACAO')
                    } else {
                      this.exibirModalSelecionarTipoDocumento = true
                    }
                  }
                }
            }
        },
        methods: {
            async buscarDocumentos() {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Carregando documentos...')
                const todosDocumentos = await this.buscarDocumentosProposta(this.licitacaoId)
                this.documentosHabilitacao = todosDocumentos.items.filter(doc => doc.tipoAnexo === 'ANEXO_HABILITACAO')
                this.documentosProposta = todosDocumentos.items.filter(doc => doc.tipoAnexo === 'ANEXO_PROPOSTA')
                this.documentosFornecedor = todosDocumentos.items.filter(doc => doc.tipoAnexo === 'ANEXO_FORNECEDOR')
                this.documentosReadequacaoProposta = await this.buscarRelatoriosReadequacaoProposta(this.licitacaoId)
                this.desabilitarLoadingGlobal()
            },
            confirmarRemocao(propostaDocumentoId) {
                this.propostaDocumentoIdRemocao = propostaDocumentoId
                this.mostrarDialogRemoverArquivo = true
            },
            confirmarSaidaDaTela(next) {
                this.mostrarDialogConfirmarSaida = true
                this.nextFunction = next
            },
            criarDocumentos(tipoDocumento) {
                const documentos = []
                const uploadedFiles = this.loki.uploadedFiles
                for (let i = 0; i < uploadedFiles.length; i++) {
                    const file = uploadedFiles[i]
                    documentos.push({
                        licitacao: {
                            id: this.licitacaoId
                        },
                        descricao: file.name,
                        tipoAnexo: tipoDocumento,
                        anexoUri: file.uri
                    })
                }
                return documentos
            },
            isUploadEmAndamento() {
                const arquivosEmProgresso = this.loki.uploadFileProgress
                const numeroArquivosEmProgresso = Object.keys(arquivosEmProgresso).length
                if (!numeroArquivosEmProgresso) {
                    return false
                }
                let isEmAndamento = false
                Object.keys(arquivosEmProgresso).forEach(chaveArquivo => {
                    const arquivo = arquivosEmProgresso[chaveArquivo]
                    if (!arquivo.error) {
                        isEmAndamento = true
                    }
                })
                return isEmAndamento
            },
            isUploadArquivosTemporariosCompleto() {
                return !this.isUploadEmAndamento() && this.loki.uploadedFiles.length > 0
            },
            async inserir(tipo) {
                this.exibirModalSelecionarTipoDocumento = false
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Salvando documentos...')
                try {
                    this.mostrarDialogConfirmarSaida = false
                    const documentos = this.criarDocumentos(tipo)
                    if(tipo === 'ANEXO_HABILITACAO') {
                      await this.inserirDocumentosHabilitacao({licitacaoId: this.licitacaoId, documentos})
                    }if(tipo === 'ANEXO_PROPOSTA') {
                      await this.inserirDocumentosProposta({licitacaoId: this.licitacaoId, documentos})
                    }
                    await this.buscarDocumentos()
                    await this.sincronizarProposta()
                    this.resetUploadedFiles()
                    this.desabilitarLoadingGlobal()
                    this.mostrarNotificacaoSucessoDefault()
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async remover() {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Removendo documento...')
                try {
                    await this.removerDocumentoProposta({
                        licitacaoId: this.licitacaoId,
                        documentoId: this.propostaDocumentoIdRemocao
                    })
                    await this.buscarDocumentos()
                    await this.sincronizarProposta()
                    this.desabilitarLoadingGlobal()
                    this.propostaDocumentoIdRemocao = false
                    this.mostrarNotificacaoSucessoDefault()
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                }
            },
            sairDaTela(next) {
                this.habilitarLoadingGlobal()
                next()
            },
            setLicitacaoId(licitacaoId) {
                this.licitacaoId = licitacaoId
            },
            async sincronizarProposta() {
                this.setMensagemLoading('Sincronizando proposta...')
                await this.buscarPropostaResumo(this.licitacaoId)
            },
            ehModoManual(){
              return this.parametros.propriedadesLicitacao.modoCriacaoProcesso === 'MANUAL'
            },
            temRelatoriosReadequacaoProposta() {
              if (this.documentosReadequacaoProposta) {
                return this.documentosReadequacaoProposta.items.length > 0
              }
              return false
            },
            abrirModalConfirmarAssinar(multiplo, doc){
              if(multiplo) {
                const todosSelecionados = this.obterSelecionados()
                if(todosSelecionados.length === 0){
                    this.mostrarNotificacaoErro("É necessário selecionar pelo menos um documento para assinar.")
                    return
                }
                const documentoVirtualizados = this.obterDocumentosVirtualizados()
                this.documentosSelecionados = documentoVirtualizados.filter(documento => {
                  return todosSelecionados.includes(documento.idVirtualizado)
                })
                this.manejandoMultiplos = multiplo
                this.exibirModalConfirmarAssinar = true
              } else {
                this.documentoSelecionado = doc
                this.documentoManejando = doc.uriVirtualizado
                this.manejandoMultiplos = multiplo
                this.exibirModalConfirmarAssinar = true
              }
            },
            assinarDocumento(url){
                window.open(url, '_blank').focus();
            },
            async assinarEmLote(){
                const todosSelecionados = this.obterSelecionados()
                const documentoVirtualizados = this.obterDocumentosVirtualizados()
                const documentos = documentoVirtualizados.filter(documento => {
                    return todosSelecionados.includes(documento.idVirtualizado)
                })
                const resultado = await this.$store.dispatch(actionTypes.FLOWBEE.ASSINAR_EM_LOTE,
                    {
                        licitacaoId: this.licitacaoId,
                        documentosIds: documentos.map(documento => documento.idVirtualizado)
                    })
                if (resultado.sucesso) {
                    this.mostrarNotificacaoSucesso("Documentos assinados com sucesso!")
                    await new Promise(resolve => setTimeout(resolve, 3000))
                    await this.buscarDocumentos()
                    this.limparSelecoes()
                } else {
                    this.mostrarNotificacaoErro("Não foi possível assinar!")
                }
            },
            async selecionarMetodoAssinar(doc, multiplos){
                this.exibirModalConfirmarAssinar = false
                if(multiplos){
                    await this.assinarEmLote();
                }else{
                    await this.assinarDocumento(doc)
                }
                this.manejandoMultiplos = false
                this.documentoManejando = null
            },
            obterSelecionadosDaTabela(ref) {
                return this.$refs[ref] && this.$refs[ref].selecionados ? this.$refs[ref].selecionados : []
            },
            obterSelecionados() {
                const selecionadosProposta = this.obterSelecionadosDaTabela('tabelaDocumentosProposta')
                const selecionadosHabilitacao = this.obterSelecionadosDaTabela('tabelaDocumentosHabilitacao')
                const selecionadosFornecedor = this.obterSelecionadosDaTabela('tabelaDocumentosFornecedor')
                const selecionadosReadequacao = this.obterSelecionadosDaTabela('tabelaDocumentosReadequacaoProposta')

                return [
                    ...selecionadosProposta,
                    ...selecionadosHabilitacao,
                    ...selecionadosFornecedor,
                    ...selecionadosReadequacao,
                ]
            },
            obterDocumentosVirtualizados() {
                const documentosProposta = this.documentosProposta || []
                const documentosHabilitacao = this.documentosHabilitacao || []
                const documentosPropostaFornecedor = this.documentosFornecedor || []
                const documentosReadequacaoProposta = this.documentosReadequacaoProposta.items || []

                return [
                    ...documentosProposta.filter(doc => doc.idVirtualizado),
                    ...documentosHabilitacao.filter(doc => doc.idVirtualizado),
                    ...documentosPropostaFornecedor.filter(doc => doc.idVirtualizado),
                    ...documentosReadequacaoProposta.filter(doc => doc.idVirtualizado),
                ]
            },
            limparSelecoes() {
                const tabelas = [
                    'tabelaDocumentosProposta',
                    'tabelaDocumentosHabilitacao',
                    'tabelaDocumentosFornecedor',
                    'tabelaDocumentosReadequacaoProposta'
                ];

                tabelas.forEach(ref => {
                    if (this.$refs[ref] && this.$refs[ref].limparSelecao) {
                        this.$refs[ref].limparSelecao()
                    }
                })
            },
            ...mapActions([
                actionTypes.BUSCAR_DOCUMENTOS_PROPOSTA,
                actionTypes.BUSCAR_PROPOSTA_RESUMO,
                actionTypes.INSERIR_DOCUMENTOS_PROPOSTA,
                actionTypes.INSERIR_DOCUMENTOS_HABILITACAO,
                actionTypes.REMOVER_DOCUMENTO_PROPOSTA,
                actionTypes.BUSCAR_RELATORIOS_READEQUACAO_PROPOSTA
            ])
        }
    }
</script>
<style lang="stylus">
.td-align
  padding-left: 12px !important

</style>
